<script setup lang="ts">
import { useTitle } from "@vueuse/core";
import BBackButton from "@/dokos-ui/components/buttons/BBackButton.vue";
import BHeader1 from "@/dokos-ui/components/layout/BHeader1.vue";
import { toRef } from "vue";

const props = defineProps<{ title?: string; backTo?: any }>();

useTitle(toRef(props, "title"));
</script>

<template>
  <header class="flex flex-wrap justify-between gap-2 items-center">
    <div class="flex items-center relative" v-if="$slots.title || title">
      <slot name="title">
        <BHeader1 class="flex" v-if="title || $slots.titleText">
          <BBackButton v-if="backTo" class="-ml-[0.125em] mr-[0.125em]" :to="backTo === true ? null : backTo" />
          <slot name="title-text">
            {{ title }}
          </slot>
        </BHeader1>
      </slot>
      <div
        aria-hidden="true"
        class="absolute w-0 h-0 flex justify-start self-start items-start pointer-events-none text-title-1"
      >
        <div
          class="h-[1em] w-[0.4em] left-[-0.2em] BLayoutPage__negate-padding !mt-0 bg-[var(--theme-primary,#1976d2)] rounded-full absolute"
        />
      </div>
    </div>

    <slot></slot>
  </header>
</template>
